exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1Z5AX {\n  padding-left: 20px;\n  padding-right: 20px;\n  cursor: pointer;\n}\n._1Z5AX .o7dOP {\n  color: #A89A72;\n  font-size: 18px;\n}\n._1Z5AX .st6sX {\n  color: #A0A0A0;\n  font-size: 12px;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "_1Z5AX",
	"title": "o7dOP",
	"desc": "st6sX"
};